import React from 'react';
import AddressBase from './AddressBase';
import Input from 'components/Input';

export default class BfpoAddress extends AddressBase {
  state = {
    houseName: null,
    address: null,
    town: null,
    postcode: null
  };

  formValid = () => !!this.state.houseName && !!this.state.address && !!this.state.town && !!this.state.postcode;

  render() {
    return (
      <div>
        <Input
          name="houseName"
          label="Service Number, Rank and Name"
          placeholder="Required"
          value={this.state.houseName || ''}
          onChange={this.handleChange}
        />

        <Input
          name="address"
          label="Company"
          placeholder="Required"
          value={this.state.address || ''}
          onChange={this.handleChange}
        />

        <Input
          name="town"
          label="Regiment"
          placeholder="Required"
          value={this.state.town || ''}
          onChange={this.handleChange}
        />

        <Input
          name="postcode"
          label="BFPO Postcode"
          placeholder="Required"
          value={this.state.postcode || ''}
          onChange={this.handleChange}
          error={this.props.errors && this.props.errors.postcode}
        />
      </div>
    );
  }
}
